import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NotFound.css';
import PageNotFoundImage from '../images/baggage.svg';

class PageNotFound extends React.Component {
  render() {
    return (
      <div>
        <div className={s.backgroundImg}>
          <div className={s.contentDiv}>
            <div className={s.titleOfError}>Oops!</div>
            <div className={s.messageOfError}>
              This page went on a journey of its own and no longer lives here.
              Try a different path or navigate <a href="/">home</a>.
            </div>
            <img className={s.contentErrorImage} src={PageNotFoundImage} />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(PageNotFound);
